import React from "react";
import "./OurStorySection.css";
import { FiTarget, FiUsers, FiShoppingCart, FiHeart } from "react-icons/fi";

// Data array for our story steps
const storySteps = [
    {
        icon: <FiTarget />,
        title: "Rooted in Tradition",
        description:
            "Vanidya began with a desire to make mindful, culturally rooted living accessible for everyone—connecting ancient wisdom with modern needs.",
    },
    {
        icon: <FiUsers />,
        title: "Empowering Authentic Sellers",
        description:
            "We partner with trusted local artisans and merchants to bring pure, Satvik, and organic products to a wider audience.",
    },
    {
        icon: <FiShoppingCart />,
        title: "Shopping with Meaning",
        description:
            "Every purchase on Vanidya supports transparent sourcing, local economies, and conscious choices that align with your values.",
    },
    {
        icon: <FiHeart />,
        title: "Real Impact, Every Day",
        description:
            "Your support helps us nurture well-being, tradition, and ethical commerce for families and communities across India.",
    },
];

const OurStorySection = () => {
    return (
        <section className="_oSect_q1A_">
            <div className="_oSCard_r2B_">
                <div
                    className="_oSCard_header_"
                    style={{ paddingBottom: "0", marginBottom: "0" }}
                >
                    <h2 className="_hTitle_s5E_ workflow-title">Our Story</h2>
                    <p className="workflow-subtitle _hSubtitle_t6F_">
                        Vanidya was created to bridge the best of Indian tradition with the convenience of digital commerce. We’re passionate about making pure, mindful living simple for everyone—today and for generations to come.
                    </p>
                </div>

                <div className="_oSCard_body_">
                    {storySteps.map((step, index) => (
                        <div className="_oSStep_ feature-item" key={index}>
                            <div className="feature-icon">{step.icon}</div>
                            <h3 className="feature-title-text">{step.title}</h3>
                            <p className="feature-description">{step.description}</p>
                        </div>
                    ))}

                    <div className="_impctBlk_gH7_">
                        <p className="_impctIntro_jK9_">
                            Every transaction makes a difference—both
                        </p>
                        <div className="_impctHlight_lP2_">
                            <span className="_impctWord_sP1_">Mindful</span>
                            <span className="_impctAnd_aN3_">&</span>
                            <span className="_impctWord_sS4_">Meaningful</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OurStorySection;